// Common style constants for PPRAPaymentPage components

export const styleInput = {
  p: '20px',
  fontSize: '14px',
  backgroundColor: 'transparent',
  color: '#183344',
  border: '1px solid #183344',
  borderRadius: '10px',
  width: '100%',
  _focus: {
    color: '#183344',
  },
  _hover: {
    backgroundColor: 'transparent',
  },
  _placeholder: {
    color: 'rgba(255, 255, 255, 0.6)',
  },
  _invalid: {
    border: '1px solid #FF9473',
    boxShadow: 'none',
  },
} as const;

export const styleInputLight = {
  ...styleInput,
  color: 'black',
  border: '1px solid black',
  _focus: {
    color: 'black',
  },
  _hover: {
    backgroundColor: 'transparent',
  },
  _placeholder: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
} as const;

export const styleTextH2 = {
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '140%',
  letterSpacing: '10%',
  textTransform: 'uppercase' as const,
  color: '#F7F4EC',
} as const;

export const styleTextH3 = {
  fontWeight: 400,
  fontSize: '22px',
  lineHeight: '130%',
  letterSpacing: '0%',
  textAlign: 'center' as const,
  color: 'darkBlue',
} as const;

export const styleTextH4 = {
  color: 'darkBlue',
  fontWeight: 400,
  fontSize: '32px',
  lineHeight: '48px',
  letterSpacing: '0.21px',
  textAlign: 'center' as const,
  verticalAlign: 'middle' as const,
} as const;

export const smallItalicText = {
  fontSize: '12px',
  fontStyle: 'italic',
  fontWeight: 400,
  lineHeight: '130%',
  color: 'tan',
} as const;

export const checkboxStyles = {
  '.chakra-checkbox__control': {
    borderRadius: '4px',
    borderColor: 'darkBlue',
    backgroundColor: 'transparent',
    display: 'flex',
    width: '25px',
    height: '25px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    _checked: {
      backgroundColor: 'lightBlue',
      borderColor: 'lightBlue',
      color: 'darkBlue',
    },
    _invalid: {
      borderColor: 'salmon-light',
    },
    color: 'tan',
  },
  '.chakra-checkbox__label': {
    display: 'flex',
    alignItems: 'center',
    height: '25px',
    padding: 0,
  },
} as const;

export const checkboxTextStyles = (isError: boolean) => ({
  variant: 'text-body-meta-regular' as const,
  ml: '0.250rem',
  color: isError ? 'salmon-light' : 'tan',
  fontSize: '14px',
  display: 'block',
  lineHeight: '140%',
});
